import {
  Box,
  Button,
  Input,
  IconButton,
  useToast,
  SimpleGrid,
  Card,
  CardBody,
  Text,
  Badge,
  VStack,
  HStack,
  Heading,
  Divider,
  Flex,
  Spacer,
  Select,
  InputGroup,
  InputLeftElement,
  Collapse,
  Alert,
  AlertIcon,
  Wrap
} from '@chakra-ui/react';
import FloatingAddButton from '../../components/FloatingAddButton';
import { useState, useEffect } from 'react';
import { MdAdd, MdSearch, MdAssessment, MdExpandMore, MdExpandLess, MdClose } from 'react-icons/md';
import { useSidebar } from '../../hooks/useSidebar';
import { useDictamenesFiltros } from '../../hooks/useDictamenesFiltros';
import ModalDictamen from './ModalDictamen';
import type { Dictamen } from './types';
import { MdHistory, MdPrint } from 'react-icons/md';
import ModalHistorialDictamen from './ModalHistorialDictamen';
import ModalDetalleDictamen from './ModalDetalleDictamen';
import { imprimirDictamen } from '../../utils/printDictamen';
import EstadisticasDictamenes from './EstadisticasDictamenes';
import FiltroRangoFechas from '../../components/filtros/FiltroRangoFechas';
import IndicadoresFiltros from '../../components/filtros/IndicadoresFiltros';
import VistaReporte from '../../components/reportes/VistaReporte';
import { ReporteService } from '../../services/reporteService';

export default function TablaDictamenes() {
  const [dictamenes, setDictamenes] = useState<Dictamen[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [dictamenEditando, setDictamenEditando] = useState<Dictamen | null>(null);
  const toast = useToast();
  const [modalHistorialOpen, setModalHistorialOpen] = useState(false);
  const [dictamenIdHistorial, setDictamenIdHistorial] = useState<number | null>(null);
  const [modalDetalleOpen, setModalDetalleOpen] = useState(false);
  const [dictamenDetalle, setDictamenDetalle] = useState<Dictamen | null>(null);
  const { mini } = useSidebar();
  const [paginaActual, setPaginaActual] = useState(1);
  const dictamenesPorPagina = 50;
  
  // Nuevos estados para reportes
  const [mostrarFiltrosAvanzados, setMostrarFiltrosAvanzados] = useState(false);
  const [modalReporteOpen, setModalReporteOpen] = useState(false);
  
  // Hook de filtros
  const {
    filtros,
    dictamenesFiltrados,
    totalFiltrados,
    hayFiltrosActivos,
    actualizarFiltro,
    limpiarFiltros,
    validarRangoFechas
  } = useDictamenesFiltros(dictamenes);
  
  const validacionFechas = validarRangoFechas();
  
  // 🔹 Obtener dictámenes desde el backend
  const fetchDictamenes = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/dictamenes?include=true`);
      const data = await res.json();
      
      if (data.success) {
        setDictamenes(data.data);
      } else {
        throw new Error(data.error || 'Error al cargar dictámenes');
      }
    } catch (err: any) {
      toast({
        title: 'Error al cargar dictámenes',
        description: err.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchDictamenes();
  }, []);

  // Usar dictámenes filtrados del hook
  const dictFiltrados = dictamenesFiltrados;

  // Paginación
  const totalPaginas = Math.ceil(dictFiltrados.length / dictamenesPorPagina);
  const indiceInicio = (paginaActual - 1) * dictamenesPorPagina;
  const indiceFin = indiceInicio + dictamenesPorPagina;
  const dictamenesPaginados = dictFiltrados.slice(indiceInicio, indiceFin);
  
  // Generar rango de fechas para reporte
  const rangoFechasReporte = ReporteService.formatearRangoFechas(
    filtros.fechaInicio,
    filtros.fechaFin,
    filtros.fechaIndividual
  );
  
  const handleGenerarReporte = () => {
    if (!validacionFechas.valido) {
      toast({
        title: 'Error en filtros',
        description: validacionFechas.mensaje,
        status: 'error',
        duration: 4000,
        isClosable: true
      });
      return;
    }
    
    if (dictFiltrados.length === 0) {
      toast({
        title: 'Sin datos para reporte',
        description: 'No hay dictámenes que coincidan con los filtros aplicados',
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
      return;
    }
    
    setModalReporteOpen(true);
  };

  // Debug: mostrar tipos únicos
  useEffect(() => {
    if (dictamenes.length > 0) {
      const tiposUnicos = [...new Set(dictamenes.map(d => d.tipo).filter(Boolean))];
    }
  }, [dictamenes]);

  const handleGuardar = (nuevo: Dictamen) => {
    // Refrescar la lista completa para obtener las relaciones
    fetchDictamenes();
    setModalOpen(false);
    setDictamenEditando(null);
  };

//   const imprimirDictamen = (datos: any) => {
//   const nuevaVentana = window.open('', '_blank', 'width=800,height=600');
//   if (!nuevaVentana) return;

//   const html = `
//  <!DOCTYPE html>
// <html lang="es">
// <head>
//   <meta charset="UTF-8">
//   <title>Dictamen de Riesgo</title>
//   <style>
//     body {
//       width: 216mm;
//       height: 279mm;
//       margin: 0 auto;
//       position: relative;
//       background-color: white;
//     }

//     p {
//       font-family: 'Arial Narrow', Arial, sans-serif;
//       font-size: 11pt;
//       line-height: 1.4;
//       text-align: justify;
//       margin-bottom: 12pt;
//     }

//     .contenedor {
//       position: relative;
//       max-width: 800px;
//       margin: auto;
//     }

//     .fondo {
//       position: absolute;
//       top: 0;
//       left: 0;
//       width: 216mm;
//       height: 305mm;
//       object-fit: cover;
//       z-index: 0;
//       opacity: 0.8;
//     }

//     .logo {
//       position: absolute;
//       top: 40px;
//       left: 40px;
//       width: 180px;
//       z-index: 0;
//       opacity: 0.9;
//     }

//     .contenido {
//       position: relative;
//       z-index: 1;
//       padding-top: 90pt;
//       padding-left: 40pt;
//       padding-right: 40pt;
//     }

//     .alineado-derecha {
//       text-align: right;
//     }

//     .centrado {
//       text-align: center;
//     }

//     .firma {
//       margin-top: 60px;
//       text-align: center;
//     }

//     .linea {
//       margin-top: 50px;
//       border-top: 1px solid #000;
//       width: 300px;
//       margin-left: auto;
//       margin-right: auto;
//     }

//     .titulo {
//       font-size: 20pt;
//       font-weight: bold;
//     }

//     .negrita {
//       font-weight: bold;
//     }

//     .espacio {
//       margin-bottom: 16px;
//     }
//   </style>
// </head>
// <body>
//   <div class="contenedor">
//     <img src="http://totolac.togui.com.mx:5000/uploads/reportes/image1.png" class="fondo" alt="Fondo">
//     <img src="http://totolac.togui.com.mx:5000/uploads/reportes/image2.png" class="logo" alt="Logo">

//     <div class="contenido">
//       <p class="alineado-derecha"><span class="negrita">DICTAMEN:</span> {{folio}}</p>
//       <p class="alineado-derecha">ÁREA: COORDINACIÓN DE PROTECCIÓN CIVIL</p>
//       <p class="alineado-derecha">TOTOLAC, TLAXCALA; {{fecha}}</p>

//       <div class="espacio"></div>

//       <p><span class="negrita">C. {{destinatario}}</span><br>
//          {{cargo}}<br>
//          DE {{localidad}}, TOTOLAC</p>

//       <p><span class="negrita">PRESENTE</span></p>

//       <h2 class="centrado titulo">DICTAMEN DE RIESGO</h2>

//       <p>{{introduccion}}</p>

//       <p>{{analisis}}</p>

//       <p>{{riesgo}}</p>

//       <p>{{recomendaciones}}</p>

//       <p class="espacio"><span class="negrita">ATENTAMENTE</span></p>

//       <div class="firma">
//         <div class="linea"></div>
//         <p class="negrita">LIC. IVÁN LANDER CORONA<br>
//         COORDINADOR DE PROTECCIÓN CIVIL</p>
//       </div>

//       <div class="firma">
//         <div class="linea"></div>
//         <p class="negrita">{{firmanteSecundario}}</p>
//       </div>
//     </div>
//   </div>
// </body>
// </html>



//   `;

//   nuevaVentana.document.write(html);
//   nuevaVentana.document.close();
// const esperarImagenes = () => {
//     const imagenes = nuevaVentana.document.images;
//     let cargadas = 0;

//     if (imagenes.length === 0) {
//       nuevaVentana.print();
//       nuevaVentana.close();
//       return;
//     }

//     for (let i = 0; i < imagenes.length; i++) {
//       const img = imagenes[i];
//       if (img.complete) {
//         cargadas++;
//         if (cargadas === imagenes.length) {
//           nuevaVentana.print();
//           nuevaVentana.close();
//         }
//       } else {
//         img.onload = () => {
//           cargadas++;
//           if (cargadas === imagenes.length) {
//             nuevaVentana.print();
//             nuevaVentana.close();
//           }
//         };
//         img.onerror = () => {
//           cargadas++;
//           if (cargadas === imagenes.length) {
//             nuevaVentana.print();
//             nuevaVentana.close();
//           }
//         };
//       }
//     }
//   };

//   // Esperar un poco antes de verificar para que el DOM se asiente
//   setTimeout(esperarImagenes, 100);

//   nuevaVentana.focus();
//   nuevaVentana.print();
// };


  return (
    <Box p={4} pt={50} width="100%" position="relative">
      {/* Estadísticas */}
      <EstadisticasDictamenes dictamenes={dictamenes} />
      
      {/* Área de búsqueda y filtros */}
      <Card mb={4} bg="#5b182b2a">
        <CardBody>
          <VStack spacing={4}>
            <Heading size="md" color="#5b182b" alignSelf="start">
              Filtros de Búsqueda
            </Heading>
            
            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} w="full">
              <InputGroup>
                <InputLeftElement pointerEvents="none">
                  <MdSearch color="gray.300" />
                </InputLeftElement>
                <Input
                  placeholder="Buscar por nombre, operador o folio"
                  value={filtros.texto}
                  onChange={e => actualizarFiltro('texto', e.target.value)}
                  bg="white"
                />
              </InputGroup>
              
              <Select
                placeholder="Tipo de dictamen"
                value={filtros.tipo}
                onChange={e => actualizarFiltro('tipo', e.target.value)}
                bg="white"
              >
                <option value="Riesgo">Riesgo</option>
                <option value="Seguridad">Seguridad</option>
                <option value="Habitabilidad">Habitabilidad</option>
              </Select>
              
              <Input
                type="date"
                placeholder="Filtrar por fecha individual"
                value={filtros.fechaIndividual}
                onChange={e => actualizarFiltro('fechaIndividual', e.target.value)}
                bg="white"
              />
              
              <Box position="relative">
                <Button
                  leftIcon={mostrarFiltrosAvanzados ? <MdExpandLess /> : <MdExpandMore />}
                  bg="white"
                  color="#bb8c52"
                  borderColor="#bb8c52"
                  variant="outline"
                  size="md"
                  borderRadius="md"
                  _hover={{ 
                    bg: "#bb8c52", 
                    color: "white",
                    transform: "translateY(-1px)",
                    boxShadow: "md"
                  }}
                  transition="all 0.2s"
                  onClick={() => setMostrarFiltrosAvanzados(!mostrarFiltrosAvanzados)}
                  w="full"
                >
                  Ver por Rango
                </Button>
                
                <Collapse in={mostrarFiltrosAvanzados} animateOpacity>
                  <Box 
                    position="absolute"
                    right={0}
                    top="100%"
                    mt={2}
                    zIndex={1000}
                    p={3} 
                    bg="white" 
                    borderRadius="md" 
                    border="1px solid" 
                    borderColor="gray.200"
                    boxShadow="lg"
                    minW="300px"
                  >
                    <FiltroRangoFechas
                      fechaInicio={filtros.fechaInicio}
                      fechaFin={filtros.fechaFin}
                      onFechaInicioChange={(fecha) => {
                        actualizarFiltro('fechaInicio', fecha);
                        if (fecha && filtros.fechaFin) {
                          setTimeout(() => setMostrarFiltrosAvanzados(false), 3000);
                        }
                      }}
                      onFechaFinChange={(fecha) => {
                        actualizarFiltro('fechaFin', fecha);
                        if (fecha && filtros.fechaInicio) {
                          setTimeout(() => setMostrarFiltrosAvanzados(false), 3000);
                        }
                      }}
                      error={!validacionFechas.valido ? validacionFechas.mensaje : undefined}
                    />
                  </Box>
                </Collapse>
              </Box>
            </SimpleGrid>
            
            <HStack spacing={3} justify="space-between" w="full">
              <HStack spacing={3}>
                <Button
                  color="#bb8c52"
                  borderColor="#bb8c52"
                  bgColor="#ffffff"
                  variant="outline"
                  size="sm"
                  onClick={limpiarFiltros}
                  isDisabled={!hayFiltrosActivos}
                >
                  Limpiar Filtros
                </Button>
                
                <Collapse in={hayFiltrosActivos} animateOpacity>
                  <Badge size={"md"} bg="#b98b54" color="white" px={2} py={1} borderRadius="md">
                    {Object.values(filtros).filter(v => v !== '').length} filtro(s) activo(s)
                  </Badge>
                </Collapse>
                
                <Collapse in={hayFiltrosActivos} animateOpacity>
                  <Button
                    leftIcon={<MdAssessment />}
                    bg="#5b182b"
                    color="white"
                    _hover={{ bg: "#691f30" }}
                    size="sm"
                    onClick={handleGenerarReporte}
                    isDisabled={!validacionFechas.valido}
                  >
                    Generar Reporte
                  </Button>
                </Collapse>
              </HStack>      
              
            </HStack>
            
            <HStack w="full" justify="space-between" align="start">
              <VStack align="start" spacing={2} flex={1}>
                <Text fontSize="sm" color="gray.600">
                  Mostrando {indiceInicio + 1}-{Math.min(indiceFin, dictFiltrados.length)} de {dictFiltrados.length} dictámenes
                </Text>
                
                <HStack spacing={3} align="center">
                  <Collapse in={hayFiltrosActivos} animateOpacity>
                    <Wrap spacing={2}>
                      {filtros.texto && (
                        <Badge
                          border="1px solid #bb8c52"
                          color="#bb8c52"
                          bg="transparent"
                          display="flex"
                          alignItems="center"
                          gap={1}
                          px={2}
                          py={1}
                          borderRadius="full"
                        >
                          Texto: "{filtros.texto}"
                          <IconButton
                            aria-label="Remover filtro texto"
                            icon={<MdClose />}
                            size="xs"
                            variant="ghost"
                            minW="auto"
                            h="auto"
                            p={0}
                            color="#bb8c52"
                            onClick={() => actualizarFiltro('texto', '')}
                          />
                        </Badge>
                      )}
                      
                      {filtros.tipo && (
                        <Badge
                          border="1px solid #bb8c52"
                          color="#bb8c52"
                          bg="transparent"
                          display="flex"
                          alignItems="center"
                          gap={1}
                          px={2}
                          py={1}
                          borderRadius="full"
                        >
                          Tipo: {filtros.tipo}
                          <IconButton
                            aria-label="Remover filtro tipo"
                            icon={<MdClose />}
                            size="xs"
                            variant="ghost"
                            minW="auto"
                            h="auto"
                            p={0}
                            color="#bb8c52"
                            onClick={() => actualizarFiltro('tipo', '')}
                          />
                        </Badge>
                      )}
                      
                      {filtros.fechaIndividual && (
                        <Badge
                          border="1px solid #bb8c52"
                          color="#bb8c52"
                          bg="transparent"
                          display="flex"
                          alignItems="center"
                          gap={1}
                          px={2}
                          py={1}
                          borderRadius="full"
                        >
                          Fecha: {new Date(filtros.fechaIndividual).toLocaleDateString('es-ES')}
                          <IconButton
                            aria-label="Remover filtro fecha"
                            icon={<MdClose />}
                            size="xs"
                            variant="ghost"
                            minW="auto"
                            h="auto"
                            p={0}
                            color="#bb8c52"
                            onClick={() => actualizarFiltro('fechaIndividual', '')}
                          />
                        </Badge>
                      )}
                      
                      {filtros.fechaInicio && (
                        <Badge
                          border="1px solid #bb8c52"
                          color="#bb8c52"
                          bg="transparent"
                          display="flex"
                          alignItems="center"
                          gap={1}
                          px={2}
                          py={1}
                          borderRadius="full"
                        >
                          Desde: {new Date(filtros.fechaInicio).toLocaleDateString('es-ES')}
                          <IconButton
                            aria-label="Remover filtro fecha inicio"
                            icon={<MdClose />}
                            size="xs"
                            variant="ghost"
                            minW="auto"
                            h="auto"
                            p={0}
                            color="#bb8c52"
                            onClick={() => actualizarFiltro('fechaInicio', '')}
                          />
                        </Badge>
                      )}
                      
                      {filtros.fechaFin && (
                        <Badge
                          border="1px solid #bb8c52"
                          color="#bb8c52"
                          bg="transparent"
                          display="flex"
                          alignItems="center"
                          gap={1}
                          px={2}
                          py={1}
                          borderRadius="full"
                        >
                          Hasta: {new Date(filtros.fechaFin).toLocaleDateString('es-ES')}
                          <IconButton
                            aria-label="Remover filtro fecha fin"
                            icon={<MdClose />}
                            size="xs"
                            variant="ghost"
                            minW="auto"
                            h="auto"
                            p={0}
                            color="#bb8c52"
                            onClick={() => actualizarFiltro('fechaFin', '')}
                          />
                        </Badge>
                      )}
                    </Wrap>
                  </Collapse>
                  

                </HStack>
              </VStack>
              
              <HStack spacing={2}>
                <Badge bg="#bb8c52" color="white" variant="solid">
                  Página {paginaActual} de {totalPaginas}
                </Badge>
                <Badge bg="#5b182b" color="white" variant="solid">
                  Total: {dictamenes.length}
                </Badge>
              </HStack>
            </HStack>
          </VStack>
        </CardBody>
      </Card>

      {/* Grid de dictámenes */}
      {dictFiltrados.length === 0 ? (
        <Card>
          <CardBody>
            <VStack spacing={4} py={8}>
              <Text fontSize="lg" color="gray.500">
                No se encontraron dictámenes
              </Text>
              <Text fontSize="sm" color="gray.400">
                {dictamenes.length === 0 
                  ? 'No hay dictámenes registrados' 
                  : 'Intenta ajustar los filtros de búsqueda'
                }
              </Text>
            </VStack>
          </CardBody>
        </Card>
      ) : (
        <SimpleGrid 
          columns={{ base: 1, md: 2, lg: 3, xl: 4,  }}     
       // columns={mini ? { base: 1, md: 2, lg: 4, xl: 5} : { base: 1, md: 2, lg: 3, xl: 4, '2xl': 5 }}
          spacing={4}
          w="100%"
          mx="auto"
          
        >
        {dictamenesPaginados.map(d => {
          const getTipoColor = (tipo: string) => {
            switch (tipo?.toLowerCase()) {
              case 'riesgo': return '#5b182b';
              case 'seguridad': return '#691f30';
              case 'habitabilidad': return '#681a2d';
              default: return '#bb8c52';
            }
          };

          const getPagoColor = (estatus: string) => {
            switch (estatus?.toLowerCase()) {
              case 'pagado': return '#bb8c52';
              case 'no pagado': return '#5b182b';
              case 'parcial': return '#691f30';
              default: return 'gray';
            }
          };

          return (
            <Card 
              key={d.id} 
              shadow="md" 
              borderRadius="lg" 
              _hover={{ shadow: 'lg', transform: 'translateY(-2px)', cursor: 'pointer' }} 
              transition="all 0.2s"
              minW="300px"
              maxW="350px"
              h="auto"
              minH="400px"
              marginRight={2}
              onClick={() => {
                setDictamenDetalle(d);
                setModalDetalleOpen(true);
              }}
            >
              <CardBody>
                <VStack align="stretch" spacing={3}>
                  {/* Header */}
                  <Flex align="center">
                    <VStack align="start" spacing={0}>
                      <Heading size="md" color="#5b182b">
                        {d.folio || `ID-${d.id}`}
                      </Heading>
                      <Text fontSize="sm" color="gray.500">
                        {d.tipo || 'Sin tipo'}
                      </Text>
                    </VStack>
                    <Spacer />
                    <Text fontSize="xs" color="gray.400">
                      #{d.id}
                    </Text>
                  </Flex>

                  <Divider />

                  {/* Información Principal */}
                  <VStack align="stretch" spacing={2}>
                    <SimpleGrid columns={2} spacing={3}>
                      <Box>
                        <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                          Solicitante
                        </Text>
                        <Text fontSize="md">{d.nombre || 'Sin nombre'}</Text>
                      </Box>
                      <Box>
                        <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                          Fecha Solicitud
                        </Text>
                        <Text fontSize="sm">{d.fechaSolicitud?.split('T')[0] || 'Sin fecha'}</Text>
                      </Box>
                    </SimpleGrid>
                    
                    <SimpleGrid columns={2} spacing={3}>
                      {/* Información específica del tipo (izquierda) */}
                      <Box>
                        {d.tipo?.toLowerCase().includes('riesgo') && d.dictamenRiesgo && (
                          <>
                            <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                              Uso de Inmueble
                            </Text>
                            <Text fontSize="sm">{d.dictamenRiesgo.usoInmueble?.descripcion || 'N/A'}</Text>
                          </>
                        )}
                        {d.tipo?.toLowerCase().includes('seguridad') && d.dictamenSeguridad && (
                          <>
                            <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                              Negocio
                            </Text>
                            <Text fontSize="sm">{d.dictamenSeguridad.denominacionNegocio || 'N/A'}</Text>
                          </>
                        )}
                        {d.tipo?.toLowerCase().includes('habitabilidad') && d.dictamenHabitabilidad && (
                          <>
                            <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                              Tipo de Inmueble
                            </Text>
                            <Text fontSize="sm">{d.dictamenHabitabilidad.tipoInmuebleCatalogo?.descripcion || 'N/A'}</Text>
                          </>
                        )}
                      </Box>
                      
                      {/* Operador (derecha) */}
                      <Box>
                        <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                          Operador
                        </Text>
                        <Text fontSize="sm">{d.operador || 'Sin asignar'}</Text>
                      </Box>
                    </SimpleGrid>

                    {/* Información adicional específica por tipo */}
                    {d.tipo?.toLowerCase().includes('riesgo') && d.dictamenRiesgo && (
                      <SimpleGrid columns={2} spacing={3}>
                        <Box>
                          <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                            Superficie
                          </Text>
                          <Text fontSize="sm">{d.dictamenRiesgo.superficie || 'N/A'} m²</Text>
                        </Box>
                        <Box>
                          <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                            Aforo
                          </Text>
                          <Text fontSize="sm">{d.dictamenRiesgo.aforo || 'N/A'} personas</Text>
                        </Box>
                      </SimpleGrid>
                    )}

                    {d.tipo?.toLowerCase().includes('seguridad') && d.dictamenSeguridad && (
                      <>
                        <SimpleGrid columns={2} spacing={3}>
                          <Box>
                            <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                              Giro
                            </Text>
                            <Text fontSize="sm">{d.dictamenSeguridad.giro || 'N/A'}</Text>
                          </Box>
                          <Box>
                            <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                              Medidas Mínimas
                            </Text>
                            <Badge 
                              colorScheme={d.dictamenSeguridad.medidasMinimas ? 'green' : 'red'}
                              variant="subtle"
                              size="sm"
                            >
                              {d.dictamenSeguridad.medidasMinimas ? 'Sí' : 'No'}
                            </Badge>
                          </Box>
                        </SimpleGrid>
                      </>
                    )}

                    {d.tipo?.toLowerCase().includes('habitabilidad') && d.dictamenHabitabilidad && (
                      <SimpleGrid columns={2} spacing={3}>
                        <Box>
                          <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                            Superficie Construida
                          </Text>
                          <Text fontSize="sm">{d.dictamenHabitabilidad.superficeConstruida || 'N/A'} m²</Text>
                        </Box>
                        <Box>
                          <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                            Niveles
                          </Text>
                          <Text fontSize="sm">{d.dictamenHabitabilidad.niveles || 'N/A'}</Text>
                        </Box>
                      </SimpleGrid>
                    )}


                  </VStack>

                  <Divider />

                  {/* Estados y Monto */}
                  <VStack align="stretch" spacing={2}>
                    <HStack justify="space-between">
                      <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                        Tipo
                      </Text>
                      <Badge 
                        bg={getTipoColor(d.tipo || '')}
                        color="white"
                        variant="solid"
                        borderRadius="full"
                      >
                        {d.tipo || 'Sin tipo'}
                      </Badge>
                    </HStack>

                    <HStack justify="space-between">
                      <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                        Estado Pago
                      </Text>
                      <Badge 
                        bg={getPagoColor(d.estatusPago || 'No pagado')}
                        color="white"
                        variant="solid"
                        borderRadius="full"
                      >
                        {d.estatusPago || 'No pagado'}
                      </Badge>
                    </HStack>

                    <HStack justify="space-between">
                      <Text fontWeight="semibold" fontSize="sm" color="gray.700">
                        Monto
                      </Text>
                      <Text fontWeight="bold" color="#bb8c52">
                        ${Number(d.montoPago ?? 0).toFixed(2)}
                      </Text>
                    </HStack>
                  </VStack>

                  <Divider />

                  {/* Acciones */}
                  <HStack spacing={2} justify="center">
                    <Button
                      size="sm"
                      color="#5b182b"
                      borderColor={"#5b182b"}
                      variant="outline"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDictamenEditando(d);
                        setModalOpen(true);
                      }}
                    >
                      Editar
                    </Button>

                    <IconButton
                      aria-label="Ver Historial"
                      icon={<MdHistory />}
                      size="sm"
                      color="#977245ff"
                      borderColor={"#bb8c52"}
                      variant="outline"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDictamenIdHistorial(d.id);
                        setModalHistorialOpen(true);
                      }}
                    />

                    <IconButton
                      aria-label="Imprimir Dictamen"
                      icon={<MdPrint />}
                      size="sm"
                      color="#681a2d"
                      borderColor={"#681a2d"}
                      variant="outline"
                      onClick={(e) => {
                        e.stopPropagation();
                        imprimirDictamen(d);
                      }}
                    />
                  </HStack>
                </VStack>
              </CardBody>
            </Card>
          );
        })}
        </SimpleGrid>
      )}
      
      {/* Paginación y Generar Reporte */}
      <VStack spacing={4} mt={6}>
        {totalPaginas > 1 && (
          <HStack justify="center" spacing={2}>
            <Button
              size="sm"
              onClick={() => setPaginaActual(1)}
              isDisabled={paginaActual === 1}
              variant="outline"
              borderColor="#bb8c52"
              color="#bb8c52"
            >
              Primera
            </Button>
            <Button
              size="sm"
              onClick={() => setPaginaActual(paginaActual - 1)}
              isDisabled={paginaActual === 1}
              variant="outline"
              borderColor="#bb8c52"
              color="#bb8c52"
            >
              Anterior
            </Button>
            <Text fontSize="sm" px={4} py={2}>
              {paginaActual} de {totalPaginas}
            </Text>
            <Button
              size="sm"
              onClick={() => setPaginaActual(paginaActual + 1)}
              isDisabled={paginaActual === totalPaginas}
              variant="outline"
              borderColor="#bb8c52"
              color="#bb8c52"
            >
              Siguiente
            </Button>
            <Button
              size="sm"
              onClick={() => setPaginaActual(totalPaginas)}
              isDisabled={paginaActual === totalPaginas}
              variant="outline"
              borderColor="#bb8c52"
              color="#bb8c52"
            >
              Última
            </Button>
          </HStack>
        )}
        

      </VStack>

      <FloatingAddButton 
        text="Nuevo Dictamen" 
        onClick={() => {
          setDictamenEditando(null);
          setModalOpen(true);
        }} 
      />
{dictamenIdHistorial !== null && (
  <ModalHistorialDictamen
    isOpen={modalHistorialOpen}
    onClose={() => {
      setModalHistorialOpen(false);
      setDictamenIdHistorial(null);
    }}
    dictamenId={dictamenIdHistorial}
  />
)}

      <ModalDictamen
        isOpen={modalOpen}
        onClose={() => {
          setModalOpen(false);
          setDictamenEditando(null);
        }}
        onGuardar={handleGuardar}
        dictamen={dictamenEditando}
      />

      <ModalDetalleDictamen
        isOpen={modalDetalleOpen}
        onClose={() => {
          setModalDetalleOpen(false);
          setDictamenDetalle(null);
        }}
        dictamen={dictamenDetalle}
      />
      
      <VistaReporte
        isOpen={modalReporteOpen}
        onClose={() => setModalReporteOpen(false)}
        dictamenes={dictFiltrados}
        filtros={filtros}
        rangoFechas={rangoFechasReporte}
      />
    </Box>
  );
}
